import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "./AvailabilityForLocationForm";
import Loading from "../../../components/Loading";
import GraphQLErrors from "../../../components/GraphQLErrors";
import {cancelChangeAvailabilityForLocation} from "../../../actions/InventoryApiActions";
import {fromJS, Map} from "immutable";
import {validatePresence} from "../../../lib/Validators";
import {createValidationErrors, createErrors} from "../../../lib/ErrorFormatter";
import {LOCATION_IN_SHOP} from "../../../queries/sales";


function validate(values) {
    let errors = Map();
    errors = validatePresence(errors, values, "availability");
    return errors.toJS();
}

const valid_availabilities = fromJS([
  {id: "available"},
  {id: "unavailable"},
  {id: "bulk-only"}
  ])

class ChangeAvailabilityForLocationFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    if (this.props.data.locationInShop.kind === "country") {
      this.submitCountry(values.get("availability"), this.props.data.locationInShop.code);
    } else {
      this.submitUsState(values.get("availability"), this.props.data.locationInShop.code);
    }
  }

  submitCountry(availability, code) {
    let updatedValues = {
      shopId: this.props.shopId,
      countryCode: code,
      availability: availability
    }
    return this.props.changeAvailabilityForCountry(updatedValues)
      .then((response) => {
        if (response.data.changeAvailabilityForCountry.errors.length <= 0) {
          this.props.cancelChangeAvailabilityForLocation();
        } else {
          let errors = createValidationErrors(response.data.changeAvailabilityForCountry.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  submitUsState(availability, code) {
    let updatedValues = {
      shopId: this.props.shopId,
      stateCode: code,
      availability: availability
    }
    return this.props.changeAvailabilityForUsState(updatedValues)
      .then((response) => {
        if (response.data.changeAvailabilityForUsState.errors.length <= 0) {
          this.props.cancelChangeAvailabilityForLocation();
        } else {
          let errors = createValidationErrors(response.data.changeAvailabilityForUsState.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelChangeAvailabilityForLocation();
  }

  render() {
    let {data} = this.props;
    if (data.loading) return <Loading />
    if (data.error) return <GraphQLErrors error={data.error} />
    let initialValues = fromJS({
      availability: data.locationInShop.availability
    })
    return (
      <Form
        availabilities={valid_availabilities}
        errors={this.state.errors}
        initialValues={initialValues}
        validate={validate}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }

}


const CHANGE_AVAILABILITY_FOR_COUNTRY = gql`
  mutation changeAvailabilityForCountry($data: CountryAvailabilityInput!) {
    changeAvailabilityForCountry(input: $data) {
      errors { key message }
    }
  }
`;

const CHANGE_AVAILABILITY_FOR_US_STATE = gql`
  mutation changeAvailabilityForUsState($data: UsStateAvailabilityInput!) {
    changeAvailabilityForUsState(input: $data) {
      errors { key message }
    }
  }
`;

const withQuery = compose(
  graphql(LOCATION_IN_SHOP, {
    options: (props) => ({
      fetchPolicy: "network-only",
      variables: {
        shopId: props.shopId,
        kind: props.kind,
        code: props.code
      }
    })
  }),
  graphql(CHANGE_AVAILABILITY_FOR_COUNTRY, {
    props: ({ mutate }) => ({
      changeAvailabilityForCountry: (data) => mutate({
        variables: { data: data }
      })
    })
  }),
  graphql(CHANGE_AVAILABILITY_FOR_US_STATE, {
    props: ({ mutate }) => ({
      changeAvailabilityForUsState: (data) => mutate({
        variables: { data: data }
      })
    })
  })  
);

const ChangeAvailabilityForLocationFormContainerWithData = withQuery(ChangeAvailabilityForLocationFormContainer);

export default connect(null, {cancelChangeAvailabilityForLocation})(ChangeAvailabilityForLocationFormContainerWithData);